import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getPriceTypes, savePriceTypesBatch } from '../../api/priceTypes';
import type { PriceType } from '../../types/PriceType';
import { t } from '../../i18n/t';

const priceTypesColumnDefs: ColDef<PriceType>[] = [
  {
    field: 'priceTypeId',
    headerName: t('priceTypes.columns.priceTypeId'),
    width: 140,
    // Natural PK: editable on Add only.
    editable: (params: EditableCallbackParams<PriceType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'priceTypeName',
    headerName: t('priceTypes.columns.priceTypeName'),
    flex: 1,
    editable: true,
  },
  {
    field: 'isSpecialRate4Valuation',
    headerName: t('priceTypes.columns.isSpecialRate4Valuation'),
    width: 180,
    editable: true,
    cellDataType: 'boolean',
  },
];

const newPriceTypeDefaults = (): Partial<PriceType> => ({
  priceTypeId: 0,
  priceTypeName: '',
  isSpecialRate4Valuation: false,
});

export function PriceTypesPage() {
  return (
    <LopCrudPage<PriceType>
      resourceCode="priceTypes"
      titleKey="priceTypes.pageTitle"
      idField="priceTypeId"
      getRows={getPriceTypes}
      saveBatch={(added, modified, deletedIds) =>
        savePriceTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={priceTypesColumnDefs}
      newRowDefaults={newPriceTypeDefaults}
    />
  );
}
